import React from "react";
import { cn } from "../../lib/cn";

export interface KpiCardProps {
  icon: React.ReactNode;
  value: React.ReactNode;
  label: string;
  delta?: string;
  trend?: "up" | "down";
  className?: string;
}

/** claudesign KPI card. Mirrors `.kpi` from docs/redesign/dashboard.css. */
export const KpiCard: React.FC<KpiCardProps> = ({
  icon,
  value,
  label,
  delta,
  trend = "up",
  className,
}) => (
  <div
    className={cn(
      "relative overflow-hidden bg-surface border border-border-soft rounded-[15px] px-[20px] py-[18px]",
      "shadow-[var(--edge-hi),0_1px_2px_rgba(0,0,0,.3)]",
      className,
    )}
  >
    {delta && (
      <span
        className={cn(
          "absolute top-[18px] right-[18px] inline-flex items-center gap-[3px] text-[12px] font-bold",
          "[&_svg]:w-[13px] [&_svg]:h-[13px]",
          trend === "up" ? "text-st-done" : "text-st-down",
        )}
      >
        {trend === "up" ? (
          <svg viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M12 5v14M5 12l7 7 7-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
        {delta}
      </span>
    )}
    <div
      className={cn(
        "grid place-items-center w-[38px] h-[38px] rounded-[11px] mb-[14px] text-cyan",
        "bg-[radial-gradient(120%_120%_at_50%_0%,rgba(61,211,230,.24),rgba(39,182,203,.05))]",
        "[&_svg]:w-[20px] [&_svg]:h-[20px]",
      )}
    >
      {icon}
    </div>
    <div className="text-white text-[28px] font-bold leading-none tracking-[-.02em]">{value}</div>
    <div className="text-muted text-[13px] mt-[7px]">{label}</div>
  </div>
);

export default KpiCard;
